import React, { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import AdminPrivateRoute from './components/AdminPrivateRoute';
import AdminRouteGuard from './components/AdminRouteGuard';

// Lazy load admin pages
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const UserManagement = lazy(() => import('./pages/UserManagement'));
const AdminUsers = lazy(() => import('./pages/AdminUsers'));
const AdminProperties = lazy(() => import('./pages/AdminProperties'));
const AdminContracts = lazy(() => import('./pages/AdminContracts'));
const AdminHierarchy = lazy(() => import('./pages/AdminHierarchy'));
const AdminRoles = lazy(() => import('./pages/AdminRoles'));
const AdminAdvertisingManagement = lazy(() => import('./pages/AdminAdvertisingManagement').then(m => ({ default: m.AdminAdvertisingManagement })));
const AdminPolicies = lazy(() => import('./pages/AdminPolicies'));
const AdminStoreItems = lazy(() => import('./pages/AdminStoreItems'));
const AdminAppDownloads = lazy(() => import('./pages/AdminAppDownloads'));

// Loading spinner component
const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#C4A35A] mx-auto"></div>
      <p className="mt-4 text-black text-sm">Đang tải...</p>
    </div>
  </div>
);

// Wrap component with Suspense
const withSuspense = (Component: React.ComponentType) => (
  <Suspense fallback={<LoadingSpinner />}>
    <Component />
  </Suspense>
);

const guarded = (path: string, Component: React.ComponentType) => (
  <AdminPrivateRoute>
    <AdminRouteGuard path={path}>{withSuspense(Component)}</AdminRouteGuard>
  </AdminPrivateRoute>
);

// Admin routes - export for main app to import
export const adminRoutes: RouteObject[] = [
  {
    path: '/admin',
    children: [
      {
        path: 'login',
        element: withSuspense(AdminLogin),
      },
      {
        path: 'dashboard',
        element: guarded('/admin/dashboard', AdminDashboard),
      },
      {
        path: 'users',
        element: guarded('/admin/users', UserManagement),
      },
      {
        path: 'hierarchy/users',
        element: guarded('/admin/hierarchy/users', AdminUsers),
      },
      {
        path: 'properties',
        element: guarded('/admin/properties', AdminProperties),
      },
      {
        path: 'contracts',
        element: guarded('/admin/contracts', AdminContracts),
      },
      {
        path: 'hierarchy',
        element: guarded('/admin/hierarchy', AdminHierarchy),
      },
      {
        path: 'roles',
        element: guarded('/admin/roles', AdminRoles),
      },
      {
        path: 'advertising-management',
        element: guarded('/admin/advertising-management', AdminAdvertisingManagement),
      },
      {
        path: 'policies',
        element: guarded('/admin/policies', AdminPolicies),
      },
      {
        path: 'store-items',
        element: guarded('/admin/store-items', AdminStoreItems),
      },
      {
        path: 'app-downloads',
        element: guarded('/admin/app-downloads', AdminAppDownloads),
      },
    ],
  },
];

